var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-lg": "" } },
        [
          _c("div", { staticClass: "spacer-15" }),
          _c("StempelkarteBig"),
          _c("div", { staticClass: "text-left mt-7 mb-4" }, [
            _c("div", [
              _c("h4", [_vm._v("Information")]),
              _vm._v(" Als "),
              _c(
                "span",
                {
                  staticClass: "text-decoration-underline pointer",
                  on: { click: _vm.goAccountOrSignin },
                },
                [_vm._v("registrierter Nutzer")]
              ),
              _vm._v(
                " kannst du Stempel sammeln. Für jede 10 Euro Umsatz erhälst du einen Stempel. Bei 10 Stempel erhälst du " +
                  _vm._s(_vm.$store.getters.stempelRabattAmount) +
                  " Euro Rabatt auf die nächste Bestellung oder eine zukünftigen Bestellung deiner Wahl. "
              ),
            ]),
          ]),
          !_vm.$store.getters.loggedIn
            ? _c("div", { staticClass: "mt-7 mb-6 text-center" }, [
                _c(
                  "div",
                  { staticClass: "d-inline-block" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-df mb-3",
                        attrs: {
                          block: "",
                          color: "primary",
                          rounded: "",
                          medium: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$ebus.$emit("goto", { name: "Anmelden" })
                          },
                        },
                      },
                      [
                        _vm._v("Zur Anmeldung "),
                        _c("v-icon", { attrs: { right: "", medium: "" } }, [
                          _vm._v("mdi-arrow-right"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-df mt-3",
                        attrs: {
                          block: "",
                          color: "primary",
                          rounded: "",
                          medium: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$ebus.$emit("goto", {
                              name: "Registrierung",
                            })
                          },
                        },
                      },
                      [
                        _vm._v("Zur Registrierung "),
                        _c("v-icon", { attrs: { right: "", medium: "" } }, [
                          _vm._v("mdi-arrow-right"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "mt-4" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }